var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wow-card',{attrs:{"elevation":"0","show-title":false}},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.gapProductList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }